<script>
export default {
  name: 'H2',
  inheritAttrs: false,
}
</script>

<template>
  <h2
    class="tw-text-xl lg:tw-text-2xl tw-font-bold tw-text-ci-gray-700"
    v-bind="$attrs"
    v-on="$listeners">
    <slot />
  </h2>
</template>
